/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs */

const en_shortcut_keys_name_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Right 1 Character`)
};

const fr_shortcut_keys_name_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer d'un caractere vers la droite`)
};

const de_shortcut_keys_name_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Zeichen nach rechts rücken`)
};

const it_shortcut_keys_name_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spostati di 1 carattere a destra`)
};

const ru_shortcut_keys_name_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместиться на 1 символ вправо`)
};

const es_shortcut_keys_name_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover 1 carácter a la derecha`)
};

const zh_cn2_shortcut_keys_name_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向右移动一个字符`)
};

const ja_shortcut_keys_name_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1文字右に移動`)
};

const hi_shortcut_keys_name_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक वर्ण दाएं जाएं`)
};

const pt_pt2_shortcut_keys_name_cc_move_right_one_character = /** @type {(inputs: Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover um caractere para a direita`)
};

/**
* | output |
* | --- |
* | "Move Right 1 Character" |
*
* @param {Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_move_right_one_character = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Move_Right_One_CharacterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_cc_move_right_one_character(inputs)
	if (locale === "de") return de_shortcut_keys_name_cc_move_right_one_character(inputs)
	if (locale === "it") return it_shortcut_keys_name_cc_move_right_one_character(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_cc_move_right_one_character(inputs)
	if (locale === "es") return es_shortcut_keys_name_cc_move_right_one_character(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_cc_move_right_one_character(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_cc_move_right_one_character(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_cc_move_right_one_character(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_cc_move_right_one_character(inputs)
	return en_shortcut_keys_name_cc_move_right_one_character(inputs)
});